import React from 'react';
import { Spin, Tag, Typography } from 'antd';
import { RichTextViewer } from '../../../components/RichTextEditor';
import { formatLogged } from '../entryTable';
import { SEVERITY_COLORS } from '../issueFields';
import type { ProgramIssue } from '../../../interfaces/CamProgramming.interface';

const { Text } = Typography;

interface EmbedIssueListProps {
	issues: ProgramIssue[];
	loading: boolean;
}

/** Compact, touch-friendly issue cards for narrow embed viewports. */
const EmbedIssueList: React.FC<EmbedIssueListProps> = ({ issues, loading }) => {
	if (loading) {
		return (
			<div className="embed-program-review__loading">
				<Spin />
			</div>
		);
	}

	if (!issues.length) {
		return (
			<div className="embed-program-review__empty">No issues logged yet</div>
		);
	}

	return (
		<div className="embed-issue-list">
			{issues.map((issue) => {
				const reporter =
					issue.reported_by?.full_name ||
					issue.reported_by?.email ||
					'Unknown';

				return (
					<article key={issue.id} className="embed-issue-card">
						<div className="embed-issue-card__header">
							<Tag color={SEVERITY_COLORS[issue.severity]} bordered={false}>
								{issue.severity_display}
							</Tag>
							<Text type="secondary" className="embed-issue-card__meta">
								{reporter} · {formatLogged(issue.created_time)}
							</Text>
						</div>
						<div className="embed-issue-card__body">
							<RichTextViewer
								html={issue.description}
								emptyText="No description"
							/>
						</div>
					</article>
				);
			})}
		</div>
	);
};

export default EmbedIssueList;
